<aside
  class="g-detail-panel h-full max-w-full"
  [class.border-l-0]="dock() === 'left'"
  [class.border-r]="dock() === 'left'"
  [class.border-default]="dock() === 'left'"
  [style.width]="width()"
  [attr.aria-label]="title()">
  <header class="g-detail-head">
    <span class="lead"
      ><i
        [class]="tab() === 'sort' ? ICONS.sortAscending : ICONS.funnel"
        aria-hidden="true"></i
    ></span>
    @if (tab(); as current) {
      <span
        class="flex gap-0.5"
        role="tablist"
        [attr.aria-label]="'features.data.path_filter.panel.tabs' | translate">
        @for (option of TABS; track option) {
          <button
            #tabButton
            type="button"
            role="tab"
            class="hover:text-text-primary cursor-pointer rounded-xs px-2 py-0.5 text-[12.5px] font-semibold transition-colors"
            [id]="tabId(option)"
            [class.text-text-tertiary]="current !== option"
            [class.text-text-primary]="current === option"
            [class.bg-interactive]="current === option"
            [attr.aria-selected]="current === option"
            [attr.aria-controls]="current === option ? tabpanelId : null"
            [tabIndex]="current === option ? 0 : -1"
            (click)="tab.set(option)"
            (keydown)="onTabKeydown($event)">
            {{ 'features.data.path_filter.panel.tab_' + option | translate }}
          </button>
        }
      </span>
    } @else {
      <span class="title">{{ title() }}</span>
    }
    <span class="mono">{{ entityType() }}</span>
    @if (count() !== null) {
      <span class="meta">{{
        'features.data.path_filter.panel.rows' | translate: { count: count() }
      }}</span>
    }
    <button
      type="button"
      class="text-text-secondary hover:bg-interactive inline-flex cursor-pointer rounded-xs p-1.5 transition-colors"
      [class.ml-auto]="count() === null"
      [attr.aria-label]="'features.data.path_filter.panel.close' | translate"
      (click)="closed.emit()">
      <i [class]="ICONS.x" aria-hidden="true"></i>
    </button>
  </header>
  @if (error(); as message) {
    <p
      role="alert"
      class="bg-danger-soft text-danger border-weak flex items-start gap-1.5 border-b px-3 py-1.5 text-xs">
      <i [class]="ICONS.warningCircle" aria-hidden="true" class="mt-0.5 shrink-0"></i>
      <span class="font-mono break-words">{{ message }}</span>
    </p>
  }
  @if (tab() === 'sort') {
    <div
      class="g-detail-body"
      role="tabpanel"
      [id]="tabpanelId"
      [attr.aria-labelledby]="tabId('sort')">
      <ng-content select="[panel-sort]" />
    </div>
    <footer class="g-detail-foot"><ng-content select="[panel-sort-footer]" /></footer>
  } @else {
    <div
      class="g-detail-body"
      [attr.role]="tab() ? 'tabpanel' : null"
      [attr.id]="tab() ? tabpanelId : null"
      [attr.aria-labelledby]="tab() ? tabId('filter') : null">
      <ng-content select="[panel-body]" />
    </div>
    @if (pin.phrase(); as phrase) {
      <ng-container [ngTemplateOutlet]="phrase" />
    }
    <ng-content select="[panel-phrase]" />
    <footer class="g-detail-foot"><ng-content select="[panel-footer]" /></footer>
  }
</aside>
